<div class="row">
    <otb-inner-breadcrumb
        *otbShowInEnv="['default', 'justice', 'finance', 'sh', 'hmdj', 'bb-jm']"
    ></otb-inner-breadcrumb>
    <otb-progress-bar></otb-progress-bar>
</div>

<div class="row">
    @if (strategy) {
        <h2>{{ strategy.notice }}</h2>
    }
</div>

@if (strategyName !== 'unknown') {
    <form [formGroup]="strategyForm" (ngSubmit)="onSubmit()" #mainForm>
        @if (strategyName === 'name') {
            <div class="row">
                <div class="col-12 col-md-5">
                    <label
                        for="nameAddition"
                        [innerHTML]="
                            'dynamische_frontend_texte.verteilmechanismen.html_content.name_addition_label'
                                | translate
                                | optional
                                | safeStyle
                        "
                    ></label>
                    <input
                        class="form-control mb-2"
                        id="nameAddition"
                        formControlName="nameAddition"
                        type="text"
                        [placeholder]="namePlaceholder"
                    />
                    <small class="text-muted">Bitte tragen Sie gegebenenfalls einen Namenszusatz ein.</small>
                </div>
                <div class="col-12 col-md-7">
                    <label for="name">{{ lastNameLabel | required }}</label>
                    <input
                        class="form-control mb-2"
                        [class.border-danger]="name.invalid && name.dirty"
                        id="name"
                        formControlName="name"
                        type="text"
                        aria-describedby="name-error-required name-error-dinSpecInvalid"
                    />
                    <otb-form-error-message
                        id="name-error-required"
                        [show]="name.invalid && name.dirty && name.errors?.['required']"
                    >
                    </otb-form-error-message>
                    <otb-form-error-message
                        id="name-error-dinSpecInvalid"
                        [show]="name.invalid && name.dirty && name.errors?.['dinSpecInvalid']"
                        [text]="'dynamische_frontend_validatoren.persönliche_daten.din_spec_91379' | translate"
                    >
                    </otb-form-error-message>
                </div>
            </div>
        }

        @if (strategyName === 'list') {
            <div class="row">
                <div class="col-12 col-md-7 mb-3">
                    <label
                        for="list"
                        [innerHTML]="
                            'dynamische_frontend_texte.verteilmechanismen.html_content.liste_überschrift'
                                | translate
                                | required
                                | safeStyle
                        "
                    ></label>
                    <ng-select
                        [items]="listEntries"
                        formControlName="list"
                        labelForId="list"
                        [clearable]="false"
                        [clearOnBackspace]="false"
                        accesskey="w"
                        [class.border-danger]="
                            strategyForm.controls['list'].invalid && strategyForm.controls['list'].dirty
                        "
                        [placeholder]="
                            'dynamische_frontend_texte.verteilmechanismen.attribute_text.liste_platzhalter' | translate
                        "
                        [markFirst]="false"
                        notFoundText="Keine Einträge gefunden"
                        [inputAttrs]="{ 'aria-describedby': 'list-error' }"
                        dropdownCustomHoverColorDirective
                        otbAnnounceSearchResults
                    >
                    </ng-select>
                    <otb-form-error-message
                        id="list-error"
                        [show]="strategyForm.controls['list'].invalid && strategyForm.controls['list'].dirty"
                    ></otb-form-error-message>
                </div>
            </div>
        }

        @if (strategyName === 'aktenzeichen') {
            <div class="row align-items-end mb-3">
                <div class="col-sm-4 col-lg-2">
                    <label
                        for="Abteilungsnummer"
                        [innerHTML]="
                            'dynamische_frontend_texte.verteilmechanismen.html_content.aktenzeichen_label_department_number'
                                | translate
                                | required
                                | safeStyle
                        "
                    ></label>
                    <otb-form-error-message
                        id="abteilungsnummer-error"
                        [show]="
                            strategyForm.controls['departmentNumbers'].invalid &&
                            strategyForm.controls['departmentNumbers'].dirty
                        "
                    ></otb-form-error-message>
                    <ng-select
                        [items]="departmentNumbers"
                        bindLabel="label"
                        bindValue="value"
                        [class.border-danger]="
                            strategyForm.controls['departmentNumbers'].invalid &&
                            strategyForm.controls['departmentNumbers'].dirty
                        "
                        labelForId="Abteilungsnummer"
                        formControlName="departmentNumbers"
                        [clearable]="false"
                        [clearOnBackspace]="false"
                        placeholder="Abteilungsnummer"
                        [markFirst]="false"
                        notFoundText="Keine Einträge gefunden"
                        [inputAttrs]="{ 'aria-describedby': 'abteilungsnummer-error' }"
                        dropdownCustomHoverColorDirective
                        otbAnnounceSearchResults
                    ></ng-select>
                </div>
                <div class="col-sm-4 col-lg-2">
                    <label
                        for="Registerzeichen"
                        [innerHTML]="
                            'dynamische_frontend_texte.verteilmechanismen.html_content.aktenzeichen_label_registration_marks'
                                | translate
                                | required
                                | safeStyle
                        "
                    ></label>
                    <otb-form-error-message
                        id="registerzeichen-error"
                        [show]="
                            strategyForm.controls['registrationMarks'].invalid &&
                            strategyForm.controls['registrationMarks'].dirty
                        "
                    ></otb-form-error-message>
                    <ng-select
                        [items]="registrationMarks"
                        bindLabel="label"
                        bindValue="value"
                        [class.border-danger]="
                            strategyForm.controls['registrationMarks'].invalid &&
                            strategyForm.controls['registrationMarks'].dirty
                        "
                        labelForId="Registerzeichen"
                        formControlName="registrationMarks"
                        [clearable]="false"
                        [clearOnBackspace]="false"
                        placeholder="Registerzeichen"
                        [markFirst]="false"
                        notFoundText="Keine Einträge gefunden"
                        [inputAttrs]="{ 'aria-describedby': 'registerzeichen-error' }"
                        dropdownCustomHoverColorDirective
                        otbAnnounceSearchResults
                    ></ng-select>
                </div>
                <div class="col-sm-4 col-lg-2">
                    <label
                        for="LaufendeNummer"
                        [innerHTML]="
                            'dynamische_frontend_texte.verteilmechanismen.html_content.aktenzeichen_label_file_number'
                                | translate
                                | required
                                | safeStyle
                        "
                    ></label>
                    <otb-form-error-message
                        id="laufendeNummer-error"
                        [show]="
                            strategyForm.controls['fileNumber'].invalid && strategyForm.controls['fileNumber'].dirty
                        "
                    ></otb-form-error-message>
                    <input
                        class="form-control"
                        id="LaufendeNummer"
                        formControlName="fileNumber"
                        type="text"
                        [class.border-danger]="
                            strategyForm.controls['fileNumber'].invalid && strategyForm.controls['fileNumber'].dirty
                        "
                        aria-describedby="laufendeNummer-error"
                    />
                </div>
                <div class="col-sm-4 col-lg-2">
                    <label
                        for="Jahresangabe"
                        [innerHTML]="
                            'dynamische_frontend_texte.verteilmechanismen.html_content.aktenzeichen_label_years'
                                | translate
                                | required
                                | safeStyle
                        "
                    ></label>
                    <otb-form-error-message
                        id="jahresangabe-error"
                        [show]="strategyForm.controls['years'].invalid && strategyForm.controls['years'].dirty"
                    ></otb-form-error-message>
                    <ng-select
                        [items]="years"
                        bindLabel="label"
                        bindValue="value"
                        [class.border-danger]="
                            strategyForm.controls['years'].invalid && strategyForm.controls['years'].dirty
                        "
                        labelForId="Jahresangabe"
                        formControlName="years"
                        [clearable]="false"
                        [clearOnBackspace]="false"
                        placeholder="Jahresangabe"
                        [markFirst]="false"
                        notFoundText="Keine Einträge gefunden"
                        [inputAttrs]="{ 'aria-describedby': 'jahresangabe-error' }"
                        dropdownCustomHoverColorDirective
                        otbAnnounceSearchResults
                    ></ng-select>
                </div>
                @if (strategyForm.controls['addition'] !== undefined) {
                    <div class="col-md-3">
                        <label
                            for="Zusatz"
                            [innerHTML]="
                                'dynamische_frontend_texte.verteilmechanismen.html_content.aktenzeichen_label_addition'
                                    | translate
                                    | required
                                    | safeStyle
                            "
                        ></label>
                        <otb-form-error-message
                            id="zusatz-error"
                            [show]="
                                strategyForm.controls['addition'].invalid && strategyForm.controls['addition'].dirty
                            "
                        ></otb-form-error-message>
                        <input
                            class="form-control"
                            id="Zusatz"
                            formControlName="addition"
                            type="text"
                            [class.border-danger]="
                                strategyForm.controls['addition'].invalid && strategyForm.controls['addition'].dirty
                            "
                            readonly
                            aria-describedby="zusatz-error"
                        />
                    </div>
                }
            </div>
        }
        <div class="row">
            <div class="col">
                <div class="form-group d-flex justify-content-between gap-2 flex-md-row flex-column mt-4">
                    <otb-back-button></otb-back-button>

                    <button
                        type="submit"
                        class="btn-success btn order-md-2 order-1 m-0 mb-3 mb-sm-0"
                        accesskey="w"
                        btnPrimaryColorDirective
                        [innerHTML]="'dynamische_frontend_texte.shared.button.next' | translate | safeStyle"
                    ></button>
                </div>
            </div>
        </div>
    </form>
} @else {
    <div class="row">
        <div class="col-12">
            <div class="alert-box">
                <div
                    class="alert alert-danger"
                    [innerHTML]="
                        'dynamische_frontend_texte.benachrichtigungen.zuordnungsstrategie_nicht_verfuegbar' | translate
                    "
                ></div>
            </div>
        </div>
        <div class="col-12">
            <otb-back-button></otb-back-button>
        </div>
    </div>
}
